

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ApiButton,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'web-library';
import { MutationStatus } from 'react-query';

const useStyles = makeStyles()((theme) =>
({
  button: {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

interface DeleteConfirmationModalProps {
  modalState: boolean;
  onDialogConfirm: () => void;
  onDialogClose: () => void;
  dialogTitle: string;
  dialogContentMsg: React.ReactNode;
  apiStatus: MutationStatus;
}

const DeleteConfirmationModal = ({
  modalState,
  onDialogConfirm,
  onDialogClose,
  dialogTitle,
  dialogContentMsg,
  apiStatus,
}: DeleteConfirmationModalProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={modalState} maxWidth="md">
      <DialogTitle>{dialogTitle}</DialogTitle>

      <DialogContent>
        <DialogContentText>{dialogContentMsg}</DialogContentText>
      </DialogContent>

      <DialogActions>
        <div className={classes.button}>
          <Button type="button" variant="text" onClick={() => onDialogClose()} id="button-cancel">
            {t('admin->>AccessArrangementConfiguration.Cancel')}
          </Button>
          <ApiButton
            type="submit"
            onClick={() => {
              onDialogConfirm();
            }}
            status={apiStatus}
            id="button-proceed-remove"
          >
            {t('admin->>AccessArrangementConfiguration.Proceed')}
          </ApiButton>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
